<div class="row">
    <div class="col-lg-4">
        <mat-card class="bg-primary">
            <mat-card-content style="margin:0 auto;">
                <div class="d-flex align-items-center" style="padding: 14px 0px;">
                    <div class="m-r-30">
                        <i-tabler name="coin-euro" class="icon-50 d-flex text-white"></i-tabler>
                    </div>
                    <div>
                        <span class="text-uppercase f-s-20 text-white">Incentivi gestione</span>
                        <h6 class="text-primary m-0 f-s-24 f-w-400 text-white" style="margin-top: 20px !important;">€
                            3.080,00</h6>
                    </div>
                    <div class="d-flex flex-column m-l-8">

                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="col-lg-4">
        <mat-card class="bg-primary">
            <mat-card-content style="margin:0 auto;">
                <div class="d-flex align-items-center" style="padding: 14px 0px;">
                    <div class="m-r-30">
                        <i-tabler name="receipt" class="icon-50 d-flex text-white"></i-tabler>
                    </div>
                    <div>
                        <span class="text-uppercase f-s-20 text-white">Incassati</span>
                        <h6 class="text-primary m-0 f-s-24 f-w-400 text-white" style="margin-top: 20px !important;">€
                            2.700,00</h6>
                    </div>
                    <div class="d-flex flex-column m-l-8">

                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="col-lg-4">
        <mat-card class="bg-primary">
            <mat-card-content style="margin:0 auto;">
                <div class="d-flex align-items-center" style="padding: 14px 0px;">
                    <div class="m-r-30">
                        <i-tabler name="chevrons-right" class="icon-50 d-flex text-white"></i-tabler>
                    </div>
                    <div>
                        <span class="text-uppercase f-s-20 text-white">Da incassare</span>
                        <h6 class="text-primary m-0 f-s-24 f-w-400 text-white" style="margin-top: 20px !important;">€
                            380,00</h6>
                    </div>
                    <div class="d-flex flex-column m-l-8">

                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>